<template>
  <div class="view-container faq-container">
    <div class="card">
      <div class="search-header">
        <div class="search-header">
          Что вы хотите найти?
        </div>
        <div class="search-block">
          <a-input
              v-model:value="searchString"
              class="search-input"
              placeholder="Выдать доступы"
              :allowClear="true"
              @pressEnter.prevent="runSearch"
          >
            <template #suffix>
              <SearchOutlined class="search-icon" />
            </template>
          </a-input>

          <a-button @click="runSearch" class="primary-button">
            Найти
          </a-button>
        </div>
      </div>

    </div>
    <div class="faq-main-wrapper">
      <div class="desktop-navigation">
        <FaqSideNavigation v-model="currentNavItem" />
      </div>
      <div class="mobile-navigation">
        <FaqMobileNav v-model="currentNavItem" />
      </div>
      <div class="card">

        <section v-if="currentBlock">
          <h1>{{ currentBlock.mainHeader }}</h1>

          <template v-for="(item, i) in currentBlock.innerBlocks" :key="i">
            <h2 v-if="item.type === 'h2'">{{ item.value }}</h2>

            <h3 v-else-if="item.type === 'h3'">{{ item.value }}</h3>

            <p v-else-if="item.type === 'text'">{{ item.value }}</p>

            <small v-else-if="item.type === 'caption'" class="caption">{{ item.value }}</small>

            <p v-else-if="item.type === 'link'">
              <a :href="item.href" target="_blank" rel="noopener" class="green-link">{{ item.text }}</a>
            </p>

            <ul v-else-if="item.type === 'list'">
              <li v-for="(li, j) in item.items" :key="j">{{ li }}</li>
            </ul>
          </template>
        </section>

        <div v-if="profile">
          <div v-if="profile === 'superadmin'">
            Показаны варианты FAQ для всех ролей
          </div>
          <div class="admin-hint" v-if="profile === 'superadmin'">
            Сотрудник
          </div>
          <StaffFAQ
              v-if="
              profile === 'staff' || profile === 'superadmin'
            "
          />
          <div class="admin-hint" v-if="profile === 'superadmin'">
            Юридическое лицо
          </div>
          <AdminFAQ v-if="profile === 'admin' || profile === 'superadmin'" />
          <div class="admin-hint" v-if="profile === 'superadmin'">Физическое лицо</div>
          <PhysicalFAQ
            v-if="profile === 'private_person' || profile === 'superadmin'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import PhysicalFAQ from "./PhysicalFAQ.vue";
import AdminFAQ from "./AdminFAQ.vue";
import StaffFAQ from "./StaffFAQ.vue";
import {ref} from "@vue/runtime-core";
import {SearchOutlined} from "@ant-design/icons-vue";
import {faqBlocks} from "@/mixins/faqText";
import FaqSideNavigation from "@/components/FAQ/FaqSideNavigation.vue";
import FaqMobileNav from "@/components/FAQ/FaqMobileNav.vue";

export default {
  components: {FaqMobileNav, FaqSideNavigation, PhysicalFAQ, AdminFAQ, StaffFAQ, SearchOutlined },
  name: "FAQ",
  setup() {
    const store = useStore();
    const profile = computed(() => store.state.profile.profile?.role);
    const currentNavItem = ref('mainBlock');
    const searchString = ref('');

    const runSearch = () => {
      currentNavItem.value = null;

      if (!searchString.value) {
        return;
      }

      const stringToSearch = new RegExp(
          searchString.value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
          "i"
      );

      for (const block of faqBlocks.blocks) {
        for (const child of block.innerBlocks) {
          if (Array.isArray(child.items)) {
            for (const listItem of child.items) {
              if (typeof listItem === "string" && stringToSearch.test(listItem)) {
                currentNavItem.value = block.block;
                return;
              }
            }
            continue;
          }

          const hay = child.value ?? child.text ?? "";

          if (typeof hay === "string" && stringToSearch.test(hay)) {
            currentNavItem.value = block.block;
            return;
          }
        }
      }
    }

    const currentBlock = computed(() =>
        faqBlocks.blocks.find((b) => b.block === currentNavItem.value)
    );

    return {
      profile,
      runSearch,
      searchString,
      currentBlock,
      currentNavItem
    };
  },
};
</script>

<style lang="scss" scoped>
.admin-hint {
  border-bottom: 1px solid var(--main-color);
  border-top: 1px solid var(--main-color);
  padding: 10px;
  margin: 20px 0;
}

.view-container {
  padding-top: 0;
}

.search-header {
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 16px;
}

.search-block {
  display: flex;
  gap: 8px;
}

.faq-container {
  h1 {
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;
  }

  h2 {
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
  }

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 120%;
  }

  p, ul {
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
  }

  .green-link {
    color: var(--main-green);
    cursor: pointer;
  }

  .green-link:hover {
    color: var(--hover-green);
  }

  .caption {
    color: var(--grey-text);
  }

  .faq-main-wrapper {
    display: flex;
    gap: 16px;

    @media (max-width: $tablet-breakpoint) {
      flex-direction: column;
    }
  }

  .desktop-navigation {
    width: 255px;
    min-width: 255px;

     @media (max-width: $tablet-breakpoint) {
       display: none;
     }
  }

  .mobile-navigation {
    display: none;
    @media (max-width: $tablet-breakpoint) {
      display: block;
    }
  }
}
</style>

<style>
.video_instruction {
  width: 800px;
  height: 600px;
}

@media (max-width: 1180px) {
  .video_instruction {
    width: 100%;
    height: 100%;
  }
}
</style>
